import { type ExternalLinkKey, type ExternalLinks, externalLinks } from './externalLinks';

export function useExternalNavigation() {
  function getUrl<K extends ExternalLinkKey>(
    key: K,
    ...args: Parameters<ExternalLinks[K]>
  ) {
    return (externalLinks[key] as (...args: Parameters<ExternalLinks[K]>) => ReturnType<ExternalLinks[K]>)(...args);
  }

  return {
    getUrl,
  };
}
